export default {
  "仅支持数字，座机需输入区号": "Only digits are supported. The area code is required for landlines",
  "请输入7-13位的数字号码": "Please enter a 7-13 digit number",
  "请输入号码": "Please enter the number",
  "请输入正确的邮箱格式": "Please enter the correct email format",
  "请先选择区号": "Please select the area code first"
}
